module.exports = __webpack_public_path__ + "static/FuturaBTMedium-16d7595cd97ac95cf01b9c545a17896b.woff2";